module.exports = __webpack_public_path__ + "img/art1.e241bd31.png";